// Shared 404 component.
//
// Used by `_error/+Page.tsx` and by every dynamic route (`/@:handle`,
// `/s/:slug`, `/category/:id`) when the requested resource does not
// exist in the current mock set. Wraps itself in `AppShell` so callers
// can render it inline without duplicating chrome.

import type { ReactNode } from "react";
import { AppShell } from "../layout/AppShell";
import { FONT_DISPLAY, PINK, VARIANT } from "../../lib/tokens";
import { useVariant } from "../../hooks/useVariant";

export interface NotFoundProps {
  /** Optional headline override (default: "Diese Seite existiert nicht."). */
  headline?: ReactNode;
  /** Optional detail line under the headline. */
  detail?: ReactNode;
  /** Optional eyebrow label above the headline (default: "Nicht gefunden"). */
  eyebrow?: string;
}

export function NotFound({ headline, detail, eyebrow = "Nicht gefunden" }: NotFoundProps) {
  const { variant } = useVariant();
  const v = VARIANT[variant];

  return (
    <AppShell currentNavId="" loggedIn={false}>
      <div
        style={{
          padding: "120px 40px",
          textAlign: "center",
          maxWidth: 640,
          margin: "0 auto",
        }}
      >
        <div
          style={{
            display: "inline-block",
            fontSize: 12,
            fontWeight: 600,
            color: PINK,
            letterSpacing: 1,
            textTransform: "uppercase",
            marginBottom: 10,
          }}
        >
          {eyebrow}
        </div>
        <h1
          style={{
            fontFamily: FONT_DISPLAY,
            fontSize: 56,
            fontWeight: 500,
            color: v.text,
            margin: 0,
            letterSpacing: -1.2,
            lineHeight: 1.0,
          }}
        >
          {headline ?? (
            <>
              Diese Seite <em style={{ color: PINK, fontStyle: "italic" }}>existiert nicht</em>.
            </>
          )}
        </h1>
        <p
          style={{
            color: v.muted,
            fontSize: 16,
            lineHeight: 1.5,
            marginTop: 24,
          }}
        >
          {detail ?? "Der Link ist abgelaufen oder nie da gewesen. Zurück zur Startseite:"}
        </p>
        <a
          href="/"
          style={{
            display: "inline-block",
            marginTop: 24,
            background: PINK,
            color: "#fff",
            padding: "11px 24px",
            borderRadius: 999,
            fontSize: 14,
            fontWeight: 600,
            textDecoration: "none",
          }}
        >
          Zur Startseite
        </a>
      </div>
    </AppShell>
  );
}
